import { MFile, MInput, MLabel, MTextArea } from "components/forms";
import React from "react";
import { Button } from "design-react-kit";
import { dateHelper } from "libs";

export class LessonActivityConfiguration {
  static forms = [{ template: "Indire" }, { template: "TirocinioDiretto" }, { template: "TirocinioDirettoIndire" }];

  //--- indire ---
  static Indire = [
    [
      {
        id: "activityDescription",
        field: "activityDescription",
        label: "Relazione sull'attività di autoformazione",
        component: MTextArea,
        rows: 8,
        className: "mb-3 col-md-12",
      },
    ],
  ];

  static dv_Indire = { activityDescription: "" };

  static em_Indire = {
    activityDescription: "La relazione deve contenere tra le 400 e le 500 battute",
  };

  static v_Indire = {
    activityDescription: (value) => value !== "" && value.length >= 400 && value.length <= 500,
  };

  /**
   * START: tirocinio diretto
   */

  static TirocinioDiretto = (context) => [
    [
      {
        id: "numHours",
        field: "numHours",
        label: "Numero ore Tirocinio Diretto",
        component: MInput,
        type: "number",
        className: "col-md-6 mt-2",
      },
      {
        id: "dateStart",
        field: "dateStart",
        label: "Data inizio tirocinio",
        component: MInput,
        type: "date",
        className: "col-md-6 mt-2",
      },
    ],
    [
      {
        field: "registroPresenze",
        label: "Registro presenze",
        //infoText: "inserisci il file del registro presenze del tirocinio diretto",
        component: MLabel,
        className: "col-md-6 pt-3 pb-0 mb-0",
      },
      {
        id: "registroPresenzeFile",
        field: "document",
        label: "registro presenze",
        component: MFile,
        config: {
          endPoint: "lesson-activity-file",
          fieldName: "document",
          maxFiles: 1,
          minFiles: 1,
          accept: ".pdf,.p7m,.xml,.doc,.docx",
          code: "registroPresenze",
        },
        className: "col-md-12 p-0 m-0",
      },
    ],
    [
      {
        field: "progettoFormativo",
        label: "Progetto formativo",
        //infoText: "inserisci il file del progetto formativo del tirocinio diretto",
        component: MLabel,
        className: "col-md-6 pt-3 pb-0 mb-0",
      },
      {
        id: "progettoFormativoFile",
        field: "document",
        label: "Progetto formativo",
        component: MFile,
        config: {
          endPoint: "lesson-activity-file",
          fieldName: "document",
          maxFiles: 2,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "progettoFormativo",
        },
        className: "col-md-12",
      },
    ],
    [
      {
        field: "relazioneFinale",
        label: "Relazione finale",
        //infoText: "inserisci il file della relazione finale del tirocinio diretto",
        component: MLabel,
        className: "col-md-6 pt-3 pb-0 mb-0",
      },
      {
        id: "relazioneFinaleFile",
        field: "document",
        label: "Relazione finale",
        component: MFile,
        config: {
          endPoint: "lesson-activity-file",
          fieldName: "document",
          maxFiles: 1,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "relazioneFinale",
        },
        className: "col-md-12",
      },
    ],
    [
      {
        field: "convenzione",
        label: "Convenzione",
        component: MLabel,
        className: "col-md-6 pt-3 pb-0 mb-0",
      },
      {
        id: "convenzioneFile",
        field: "document",
        label: "Convenzione",
        component: MFile,
        config: {
          endPoint: "lesson-activity-file",
          fieldName: "document",
          maxFiles: 1,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "convenzione",
        },
        className: "col-md-12",
      },
    ],
    [
      {
        id: "schoolCode",
        field: "schoolCode",
        infoText: "Inserire il codice e premere il pulsante 'valida codice'",
        label: "Codice meccanografico istituto",
        component: MInput,
        type: "text",
        className: "col-md-6 mt-3",
        onChange: (field, value) => context.onSchoolCodeChange(field, value),
      },
      {
        id: "validateSchoolBtn",
        field: "validateSchoolBtn",
        className: "col-md-2 mt-2",
        component: (props) => (
          <Button {...props} type="button" onClick={context.verifySchool} color="primary bg-dark">
            Valida codice
          </Button>
        ),
      },
    ],
  ];

  static dv_TirocinioDiretto = {
    numHours: "",
    dateStart: "",
    registroPresenzeFile: null,
    progettoFormativoFile: null,
    relazioneFinaleFile: null,
    convenzioneFile: null,
    schoolCode: "",
  };

  static em_TirocinioDiretto = {
    numHours: "Inserire un numero di ore valido tra 1 e 180",
    dateStart: "Inserire una data di inizio del tirocinio valida",
    schoolCode: "Inserire un codice meccanografico valido",
  };

  static v_TirocinioDiretto = {
    numHours: (value) => {
      const num = parseInt(value);
      return value !== "" && !isNaN(num) && num > 0 && num <= 180;
    },
    dateStart: (value) => {
      if (value === "") return false;
      return dateHelper.noFuture(value);
    },
    schoolCode: (value, state) => {
      if (value === "" || value.length !== 10) return false;
      if (!state.checkSchool) return true;

      return state.isSchoolVerified === true;
    },
  };

  /**
   * END: tirocinio diretto
   */

  /**
   * START: tirocinio diretto indire
   */

  static TirocinioDirettoIndire = [
    [
      {
        id: "numHours",
        field: "numHours",
        label: "Numero ore Tirocinio Diretto",
        component: MInput,
        type: "number",
        className: "col-md-4 mt-2",
      },
    ],
    [
      {
        field: "registroPresenze",
        label: "Registro presenze",
        //infoText: "inserisci il file del registro presenze del tirocinio diretto",
        component: MLabel,
        className: "col-md-6 pt-3 pb-0 mb-0",
      },
      {
        id: "registroPresenzeFile",
        field: "document",
        label: "registro presenze",
        component: MFile,
        config: {
          endPoint: "lesson-activity-file",
          fieldName: "document",
          maxFiles: 1,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "registroPresenze",
        },
        className: "col-md-12 p-0 m-0",
      },
    ],
    [
      {
        field: "progettoFormativo",
        label: "Progetto formativo",
        //infoText: "inserisci il file del progetto formativo del tirocinio diretto",
        component: MLabel,
        className: "col-md-6 pt-3 pb-0 mb-0",
      },
      {
        id: "progettoFormativoFile",
        field: "document",
        label: "Progetto formativo",
        component: MFile,
        config: {
          endPoint: "lesson-activity-file",
          fieldName: "document",
          maxFiles: 2,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "progettoFormativo",
        },
        className: "col-md-12",
      },
    ],
    [
      {
        field: "schedaValutativa",
        label: "Scheda Valutativa",
        //infoText: "inserisci il file della relazione finale del tirocinio diretto",
        component: MLabel,
        className: "col-md-6 pt-3 pb-0 mb-0",
      },
      {
        id: "schedaValutativaFile",
        field: "document",
        label: "Scheda Valutativa",
        component: MFile,
        config: {
          endPoint: "lesson-activity-file",
          fieldName: "document",
          maxFiles: 1,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "schedaValutativa",
        },
        className: "col-md-12",
      },
    ],
  ];

  static dv_TirocinioDirettoIndire = {
    numHours: "",
    registroPresenzeFile: null,
    progettoFormativoFile: null,
    schedaValutativaFile: null,
  };

  static em_TirocinioDirettoIndire = {
    numHours: "Inserire un numero di ore valido tra 1 e 150",
  };

  static v_TirocinioDirettoIndire = {
    numHours: (value) => {
      const num = parseInt(value);
      return value !== "" && !isNaN(num) && num > 0 && num <= 150;
    },
  };

  //--- generic methods ---
  static getDefaultValues(template) {
    return this["dv_" + template];
  }

  static getFields(template, context) {
    const fields = this[template];
    return typeof fields === "function" ? fields(context) : fields;
  }

  static getErrorMessages(template) {
    return this["em_" + template];
  }

  static getValidators(template) {
    return this["v_" + template];
  }

  static getPageTitle(template) {
    switch (template) {
      case "Indire":
        return "Relazione sull'attività di autoformazione";
      case "TirocinioDiretto":
        return "Documentazione Tirocinio Diretto";
      case "TirocinioDirettoIndire":
        return "Documentazione Tirocinio Diretto";
      default:
        return "";
    }
  }
}
